import { IActionContext } from '../helpers/ActionContext';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Subscriptions } from '../resources/Subscriptions';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ToasterService, ToastType } from './ToasterService';

export enum SubscriptionFormat {
  Image = 1 << 0,
  Pdf = 1 << 1
}

export interface IChangeSubscriptionsFormatDialogScope extends ng.IScope {
  formatOptions: {
    id: SubscriptionFormat;
    label: string;
  }[];
  selected: {
    id: SubscriptionFormat;
  };
}

export class ChangeSubscriptionsFormatAction {

  public static $inject = ['ConfirmActionDialog', '$translate', 'ToasterService', 'Subscriptions'];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private toaster: ToasterService,
    private Subscriptions: Subscriptions) { }

  public changeFormat(subscriptions: Set<ISubscriptionInfo>, context: IActionContext): ng.IPromise<IResult> {
    const scope = <IChangeSubscriptionsFormatDialogScope> context.scope.$new();
    const subscription = subscriptions.first();
    const initialAttachImage: boolean = subscription.attachImage;
    const initialAttachPdf: boolean = subscription.attachPdf;
    const initialSelectedId = (initialAttachImage ? SubscriptionFormat.Image : 0) |
      (initialAttachPdf ? SubscriptionFormat.Pdf : 0);

    scope.formatOptions = [
      {'id': SubscriptionFormat.Image, 'label': this.$translate.instant('changeSubscriptionsFormatOptionImage')},
      {'id': SubscriptionFormat.Pdf, 'label': this.$translate.instant('changeSubscriptionsFormatOptionPDF')},
      {'id': SubscriptionFormat.Image | SubscriptionFormat.Pdf, 'label': this.$translate.instant('changeSubscriptionsFormatOptionImagePDF')}
    ];
    scope.selected = {
      'id': initialSelectedId
    };

    return this.ConfirmActionDialog.open({
      title: this.$translate.instant('confirmChangeSubscriptionsFormat'),
      bodyTemplateUrl: 'confirmActionDialogInputSelect.html',
      scope: scope,
      confirmDisabled: () => subscriptions.size() === 1 && scope.selected.id === initialSelectedId,
      actionName: this.$translate.instant('confirmChangeSubscriptionsFormat'),
      action: (dialogInstance: IConfirmActionDialogInstance) => {
        const selectedAttachImage: boolean = !!(scope.selected.id & SubscriptionFormat.Image);
        const selectedAttachPdf: boolean = !!(scope.selected.id & SubscriptionFormat.Pdf);
        return this.Subscriptions.changeFormat(subscriptions.map(sub => sub.id), selectedAttachImage, selectedAttachPdf).then((
          result: IResult) => {
          if (result.errors && result.errors.length) {
            dialogInstance.showErrorMessage(
              this.$translate.instant('changeSubscriptionsFormatFailure'));
          } else {
            this.toaster.pop({
              type: ToastType.Info,
              text: this.$translate.instant('changeSubscriptionsFormatSuccess'),
              testId: 'change-subscription-format-success'
            });
            subscription.attachImage = selectedAttachImage;
            subscription.attachPdf = selectedAttachPdf;
          }
          return result;
        });
      }
    }).result.finally(() => {
      scope.$destroy();
    });
  }

}

Module.instance().service('ChangeSubscriptionsFormatAction', ChangeSubscriptionsFormatAction);
